import React, { useState } from "react";
import { FaUser, FaPhone, FaEnvelope } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
import sample from "../assets/register.png";
import { toast } from "react-toastify";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import { useNavigate } from "react-router-dom";
export default function SignIn() {
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [mobile, setMobile] = useState("");
    const [email, setEmail] = useState("");
    const [errors, setErrors] = useState({});
    const [agree, setAgree] = useState(false);
    const navigate = useNavigate();
    const validate = () => {
        const errs = {};
        if (!name) errs.name = "Name is required";
        if (!mobile) errs.mobile = "Mobile number is required";
        else if (!/^\d{10}$/.test(mobile))
            errs.mobile = "Mobile number must be 10 digits";
        if (!email) errs.email = "Email is required";
        else if (!/\S+@\S+\.\S+/.test(email)) errs.email = "Invalid email";
        return errs;
    };
    const handleRegister = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length > 0) {
            Object.values(validationErrors).forEach(err => {
                toast.error(err);
            });
            return;
        }
        if (Object.keys(validationErrors).length === 0) {
            setLoading(true);
            const addData = {
                first_name: name,
                last_name: "",
                mobile_number: mobile,
                email_id: email,
                password: "123456"
            };
            try {
                let url = webEndPoint + "user";
                const response = await makeRequest("post", url, addData);
                if (response) {
                    setLoading(false);
                    toast.success("User Registered successfully!");
                    setName("");
                    setMobile("");
                    setEmail("");
                    navigate(`/signin`);
                }
            } catch (err) {
                if (err?.message) {
                    toast.error(err.message);
                } else {
                    toast.error(err.message || "Something went wrong");
                }
            } finally {
                setLoading(false);
            }
        }
    };
    return (
        <div className="page-container">
            <Header />
            {loading && (
                <div className="glass-loader">
                    <div className="modern-spinner"></div>
                </div>
            )}
            <div className="register-wrapper">
                <div className="register-left">
                    <div className="image-container">
                        <img src={sample} alt="fashion" className="responsive-img" />
                    </div>
                </div>
                <div className="register-right">
                    <div className="register-card">
                        <h2>Create Account</h2>
                        <p className="subtitle">Join Senthan Amuthan</p>
                        <form onSubmit={handleRegister} className="register-form">
                            <div className="input-group">
                                <FaUser />
                                <input type="text" placeholder="Full Name" value={name} onChange={(e) => setName(e.target.value)} />
                            </div>
                            <div className="input-group">
                                <FaPhone />
                                <input type="text" placeholder="Mobile Number" value={mobile} onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))} />
                            </div>
                            <div className="input-group">
                                <FaEnvelope />
                                <input type="email" placeholder="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} />
                            </div>
                            <div className="terms">
                                <label className="custom-checkbox">
                                    <input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} />
                                    <span className="checkmark"></span>I agree to the{" "}
                                    <a href="/terms-and-condition" target="_blank">Terms & Conditions</a>{" "}and{" "}<a href="/privacy-policy" target="_blank">Privacy Policy</a>
                                </label>
                            </div>
                            <button type="submit" className="register-btn" disabled={!agree}>Create Account</button>
                            <p className="login-link">Already have an account? <a href="/signin">Sign In</a></p>
                        </form>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}